<ng-container *ngIf="products$ | async as products">
  <ng-container *ngIf="products.length && data && data.displayMode === displayModes.Slider">
    <py-product-carousel [hideOverflow]="true" [items]="products" [title]="data.tileTitle"></py-product-carousel>
  </ng-container>

  <ng-container *ngIf="data?.displayMode === displayModes.Grid">
    <ng-container *ngIf="data.tileTitle">
      <h1 *ngIf="getHasClass('h1', data.styleClasses)">{{ data.tileTitle }}</h1>
      <h2 *ngIf="getHasClass('h2', data.styleClasses)">{{ data.tileTitle }}</h2>
      <h3 *ngIf="getHasClass('h3', data.styleClasses)">{{ data.tileTitle }}</h3>
      <h4 *ngIf="getHasClass('h4', data.styleClasses)">{{ data.tileTitle }}</h4>
      <h5 *ngIf="getHasClass('h5', data.styleClasses)">{{ data.tileTitle }}</h5>
      <h6 *ngIf="getHasClass('h6', data.styleClasses)">{{ data.tileTitle }}</h6>

      <h2 *ngIf="getHasNoTitleClass(data.styleClasses)" class="mb-4">{{ data.tileTitle }}</h2>
    </ng-container>
    <div class="catalog-list">
      <ng-container *ngFor="let product of products">
        <py-catalog-product-list-item
          *ngIf="product.product"
          [id]="product.product.code"
          [product]="product.product"
          [isSecondaryVersion]="catalogProductItemSecondary$ | async"
          class="px-4 catalog-list-item mb-8"
        ></py-catalog-product-list-item>
      </ng-container>
    </div>
  </ng-container>
</ng-container>
